import dayjs from "dayjs";
import { stateOptions } from "@/config";
import customParseFormat from 'dayjs/plugin/customParseFormat';

dayjs.extend(customParseFormat);
const program = JSON.parse(localStorage.getItem("Program") || '{}');
const programName = program?.name?.toUpperCase();

export default { 
  patientFields: [
   {
    name: 'patient_first_name',
    label: 'Patient First Name',
    type: 'input',
    required: true,
    span: 12,
   },
   {
    name: 'patient_last_name',
    label: 'Patient Last Name',
    type: 'input',
    required: true,
    span: 12,
   },
   {
    name: 'patient_date_of_birth',
    label: 'Date of Birth',
    placeholder: 'MM-DD-YYYY',
    type: 'datePicker',
    required: true,
    style: {
      width: '100%'
    },
    span: 12
   },
   {
    name: 'patient_gender',
    label: 'Gender',
    type: 'select',
    required: true,
    span: 12,
    options: [
      { label: 'Male', value: "male" },
      { label: 'Female', value: "female" },
    ],
   },
   {
    name: 'patient_address_line1',
    label: 'Patient Address Line',
    type: 'input',
    required: true,
    span: 12,
   },
   {
    name: 'patient_address_line2',
    label: 'Patient Address Line 2',
    type: 'input',
    span: 12,
   },
   {
    name: 'patient_city',
    label: 'Patient City',
    type: 'input',
    required: true,
    span: 12,
   },
   {
    name: 'patient_state',
    label: 'Patient State',
    type: 'select',
    required: true,
    span: 12,
    options: stateOptions,
   },
   {
    name: 'patient_zip_code',
    label: 'Patient ZIP',
    type: 'otp',
    length: 5,
    required: true,
    span: 12,
   },
   {
    name: 'patient_current_therapy',
    label: 'Current Therapy',
    type: 'textarea',
    required: true,
    span: 12,
   },
   {
    name: 'patient_cell_number',
    label: 'Patient Cell Number',
    type: 'otp',
    length: 10,
    required: true,
    span: 12,
   },
   {
    name: 'patient_contact_name',
    label: 'Contact Name (If other than patient)',
    type: 'input',
    required: true,
    span: 12,
   },
   {
    name: 'patient_phone_number',
    label: 'Contact Phone Number (If other than patient)',
    type: 'otp',
    length: 10,
    span: 12,
   },
   {
    name: 'patient_contact_relationship',
    label: 'Contact Relationship',
    type: 'input',
    required: true,
    span: 12,
   },
   {
    name: 'patient_email',
    label: 'Email',
    type: 'input',
    span: 12,
   }
  ],
  prescriberFields: [
    {
        name: 'prescriber_first_name',
        type: 'input',
        label: 'Prescriber First Name',
        required: true,
        span: 12,
    },
    {
        name: 'prescriber_last_name',
        type: 'input',
        label: 'Prescriber Last Name',
        required: true,
        span: 12,
    },
    {
      name: 'prescriber_facility_name',
      type: 'input',
      label: 'Facility Name',
      required: true,
      span: 12
    },
    {
      label: 'Prescriber address',
      name: 'prescriber_address_line1',
      type: 'text',
      span: 12,
      required: true,
      placeholder: 'Please enter the address'
    },
    {
      label: 'Prescriber address line 2',
      name: 'prescriber_address_line2',
      type: 'text',
      span: 12,
      placeholder: 'Please enter the address line 2'
    },
    {
      label: 'Prescriber city',
      name: 'prescriber_city',
      type: 'text',
      span: 12,
      required: true,
      placeholder: 'Please enter the city'
    },
    {
      label: 'Prescriber state',
      name: 'prescriber_state',
      type: 'select',
      span: 12,
      required: true,
      options: stateOptions,
      placeholder: 'Please select the state'
    },
    {
      label: 'Prescriber zip code',
      name: 'prescriber_zip_code',
      type: 'otp',
      length: 5,
      span: 12,
      required: true
    },
    {
      label: 'State License Number',
      name: 'prescriber_state_license_number',
      type: 'input',
      span: 12,   
      required: true
    },
    {
      label: 'NPI Number',
      name: 'prescriber_npi',
      type: 'otp',
      length: 10,
      span: 12,
      required: true
    },
    {
      label: 'Office Contact Name',
      name: 'prescriber_office_contact_name',
      type: 'input',
      span: 12,
      required: true,
    },
    {
      label: 'Mobile Phone Number',
      name: 'prescriber_phone_number',
      type: 'otp',
      length: 10,
      span: 12,
      required: true
    },
    {
      label: 'Fax Number',
      name: "prescriber_fax_number",
      type: "otp",
      length: 10,
      span: 12,
      required: true,
    },
    {
      label: 'Email',
      name: 'prescriber_email',
      type: 'input',
      span: 12,
      required: true,
    },
  ],
  prescriptionFields: [
    {
      label: programName + ' Antihemophilic Factor (Recombinant)',
      name: 'prescription_antihemophilic_factor',
      type: 'input',
      required: true,
      span: 12,
    },
    {
      label: "Available Vial Sizes",
      name: "prescription_available_vial_sizes",
      type: "input",
      required: true,
      span: 12,
      placeholder: "250 IU, 500 IU, 1000 IU, etc., up to 4000 IU"
    },
    {
      label: "Patient Weight",
      name: "prescription_patient_weight",
      type: "input",
      required: true,
      span: 8,
    },
    {
      label: " ",
      name: "prescription_patient_weight_unit",
      type: "select",
      span: 4,
      required: true,
      options: [
        { value: "kg", label: "kg" },
        { value: "lb", label: "lb" },
      ]
    },
    {
      label: "Dose IU/kg",
      name: "prescription_dose",
      type: "input",
      required: true,
      span: 12,
    },
    {
      label: "Total IU required for one dose",
      name: "prescription_total_required_for_one_dose",
      type: "input",
      required: true,
      span: 12,
    },
    {
      label: "Product shipping option",
      name: "prescription_product_shipping_option",
      type: "select",
      span: 12,
      options: [
        { value: "prescriber", label: "Prescriber" },
        { value: "patient", label: "Patient" },
      ]
    },
    {
      label: "Shipping Address",
      name: "prescription_address_line1",
      type: "input",
      span: 12,
    },
    {
      label: 'Shipping Address Line 2',
      name: 'prescription_address_line2',
      type: 'input',
      span: 12,
    },
    {
      label: 'Shipping City',
      name: 'prescription_city',
      type: 'input',
      span: 12,
    },
    {
      label: 'Shipping State',
      name: 'prescription_state',
      type: 'select',
      options: stateOptions,
      span: 12,
    },
    {
      label: 'Shipping Zip Code',
      name: 'prescription_zip_code',
      type: 'otp',
      length: 5,
      span: 12,
    },
    {
      label: "Additional Prescriber Instructions",
      name: "prescription_additional_prescriber_instructions",
      span: 12,
      type: "textarea",
    }
  ],
  signatureFields: [
    {
      label: 'Prescriber e-signature',
      name: 'prescription_e_signature',
      type: 'input',
      required: true,
      span: 12,
    },
    {
      label: 'Date',
      name: 'prescription_signature_date',
      type: 'datePicker',
      span: 12,
      defaultValue: dayjs(),
      disabled: true,
      style: { width: '100%' }
    }
  ]
}